import theme from 'src/theme';

export const tableToolbarSx = {
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        pt: 1.5,
        pb: 1,
        lineHeight: 1,
        flexWrap: 'wrap' as const,
        rowGap: 1,
    },
    titleIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        borderRadius: '6px',
        bgcolor: 'rgba(0, 127, 220, 0.10)',
        color: theme.palette.primary.main,
        flexShrink: 0,
        '& svg': {
            fontSize: '14px',
            display: 'block',
        },
    },
    titleText: {
        fontSize: '0.82rem',
        fontWeight: 600,
        color: theme.palette.neutral[800],
        letterSpacing: '-0.01em',
        lineHeight: 1,
        display: 'inline-block',
    },
    rightSide: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ml: 'auto',
        flexShrink: 0,
    },
    titleCount: {
        fontSize: '0.7rem',
        fontWeight: 600,
        color: theme.palette.neutral[400],
        letterSpacing: '0.02em',
        lineHeight: 1,
        display: 'inline-block',
    },
    searchInput: {
        '& .MuiOutlinedInput-root': {
            height: 28,
            fontSize: '0.72rem',
            borderRadius: '8px',
            bgcolor: theme.palette.common.white,
        },
        '& .MuiOutlinedInput-input': {
            py: 0.5,
            px: 1,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.08)',
        },
        width: 160,
    },
    searchAdornment: {
        fontSize: 14,
        color: theme.palette.neutral[400],
    },
    iconButton: {
        width: 28,
        height: 28,
        borderRadius: '8px',
        color: theme.palette.neutral[500],
        bgcolor: theme.palette.common.white,
        border: '1px solid rgba(0, 0, 0, 0.06)',
        '&:hover': {
            bgcolor: theme.palette.neutral[50],
            color: theme.palette.primary.main,
        },
        '& svg': {fontSize: 14},
    },
};
